<template>
  <p class="FootnoteDisclaimer">
    <sup>{{ sup }}</sup>{{ description }}
  </p>
</template>

<script setup lang="ts">

withDefaults(defineProps<{
  sup?: string,
  description?: string,
}>(), {
  sup: '0',
  description: '',
});
</script>